import Section from "../../common/Section/index";
import Header from "../../common/Header/index";
import Container from "../../common/Container/index";
import { Image, ImageList } from "./styled";

function AuthorPage() {

  return (

    <Container>

      <Header
        title="O autorze"
      />

      <Section
        title="Michał Kowalczyk"
        body={
          <>
            <h3>
              Cześć. Z wykształcenia jestem architektem po studiach 5-letnich, natomiast postanowiłem sprawdzić się w innej dziedzinie ✊.
              Moje motto życiowe to:
            </h3>
            <h4>"Po co gadać, jeśli wszystko wiadomo, a jeśli nic
              nie wiadomo, to po co gadać?"
            </h4>
            <p>W wolnym czasie lubię m.in. malować. Poniżej praca, którą aktualnie tworzę z anime "Demon Slayer"</p>
            <Image>
              <ImageList src="https://i.postimg.cc/1RqcPnqQ/Obraz.jpg" />
            </Image>
          </>
        }
      />

    </Container>
  );
}

export default AuthorPage;